import 'cropperjs/dist/cropper.css'
import './ImageCropper.scss';

import React from 'react';
import Cropper from 'react-cropper';

import Button from 'components/Button';

export default class ImageCropper extends React.Component {
    static propTypes = {
        file: React.PropTypes.object.isRequired,
        handleCancel: React.PropTypes.func.isRequired,
        handleCrop: React.PropTypes.func.isRequired
    };

    _handleCrop() {
        this.refs.cropper.getCroppedCanvas().toBlob((newBlob) => {
            newBlob.lastModified = new Date().getTime();
            newBlob.lastModifiedDate = new Date();
            newBlob.name = this.props.file.name.split('.')[0] + '.jpg';
            newBlob.preview = window.URL.createObjectURL(newBlob);

            this.props.handleCrop(newBlob);
        }, 'image/jpg', 1);

    }

    render() {
        return (
            <div className="c-image-cropper">
                <Cropper
                    aspectRatio={1}
                    ref="cropper"
                    src={this.props.file.preview}
                />
                <div className="image-cropper__button--wrapper">
                    <Button className="image-cropper__button" onClick={this.props.handleCancel.bind(this)}>
                        Cancel
                    </Button>
                    <Button className="image-cropper__button" onClick={this._handleCrop.bind(this)}>
                        Use Photo
                    </Button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ImageCropper/index.js